import React from 'react'
import { Container } from '@sainsburys-tech/fable'

const RAMSItems = [
  'Risk Assessment and Method Statements (RAMS) must exist to cover the work you are completing on site today',
  'RAMS must not have expired',
  'Work not covered within generic RAMS must have task specific RAMS produced',
  'RAMS should be readily available for review and inspection at all times',
  'If you are not sure if the work you are on site to complete is covered by RAMS in place then you must decline this statement, sign out of site and not complete the work'
]

const RAMSSafetyPolicy = () => (
  <Container>
    <h3 className="dsib-policyWording__title">RAMS Safety Statement</h3>
    <ul className="dsib-policyWording__list">
      {RAMSItems.map((item, index) => (
        <li key={index} className="dsib-policyWording__listItem">{item}</li>
      ))}
    </ul>
  </Container>
)

export default RAMSSafetyPolicy
